<template>
    <div>
        <reviews-card
            :title="domain['name_'+registration.degree.lang]"
            :help="domain['description_'+registration.degree.lang]"
            :lang="registration.degree.lang"
            :id="domain.id"
                        :registration="registration"
            :simulations="simulations"
            :rating-options="ratingOptions"
        ></reviews-card>

        <h6 class="competencies-title">
            {{ $t('common.competencies') }}
            <span v-if="registration.degree.simulation_role_2 && hasSecondGrid">
                : {{ registration.degree.simulation_role_1_name[registration.degree.lang] }}
            </span>
        </h6>

        <competencies
            :simulations="simulations"
            :competencies="competencies"
            :position1-competencies="position1Competencies"
            :position2-competencies="position2Competencies"
            :registration="registration"
            :rating-options="ratingOptions"
            :num="1"
            :domain="domain">
        </competencies>

        <div v-if="registration.degree.simulation_role_2 && hasSecondGrid">

            <h6 class="competencies-title">
                {{ $t('common.competencies') }}:
                {{ registration.degree.simulation_role_2_name[registration.degree.lang] }}
            </h6>

            <competencies
                :simulations="simulations"
                :competencies="competencies"
                :position1-competencies="position1Competencies"
                :position2-competencies="position2Competencies"
                :registration="registration"
                :rating-options="ratingOptions"
                :num="2"
                :domain="domain">
            </competencies>
        </div>
    </div>
</template>

<script>
    import Competencies from './Competencies';
    import ReviewsCard from './ReviewsCard';

    export default {

        components: {
            Competencies, ReviewsCard
        },

        props: {

            domain: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            simulations: {
                type: Array,
                required: true
            },

            competencies: {
                type: Object,
            },

            position1Competencies: {
                type: Object,
            },

            position2Competencies: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
                required: true
            },
        },

        computed: {
            
            hasSecondGrid() {
                for (var index in this.simulations) {
                    if (this.simulations[index].grid2_id) {
                        return true
                    }
                }
                return false
            }
        }
    }
</script>

<style scoped>

    .tabs >>> .nav-pills {
        padding-top: 0;
        padding-bottom: 1.5rem;
    }
    .competencies-title {
        text-transform: uppercase;
        margin-top: 2rem;
        padding-left: 0.5rem;
        font-size: 1rem;
    }

</style>
